import React, {Suspense} from 'react'
import { Router, Switch, Redirect, Route } from 'react-router-dom'
import { PublicRoute } from './permissions/PublicRoute'
import * as Routes from './routes'
import { history } from "./history";
import {PrivateRouteV2} from '~/router/permissions/PrivateRouteV2';
import {privateMappings} from '~/router/mapping';
import NotFoundPageComponent from '@components/layout/not-foung-page/not-foung-page.component';
import PreloaderContainer from '@components/layout/preloader/preloader.component';

const AppRouter = () => (
    <Router history={history}>
        <Switch>
            <Redirect
                from={Routes.ROOT}
                to={Routes.LOGIN}
                exact={true}
            />
            <PublicRoute
                path={Routes.LOGIN}
                exact={true}
            />
            <PublicRoute
                path={Routes.REGISTRATION}
                exact={true}
            />
            <PublicRoute
                path={Routes.FORGOT_PASSWORD}
                exact={true}
            />
            <PublicRoute
                path={Routes.RESET_PASSWORD}
                exact={true}
            />
            <PublicRoute
                path={Routes.STORE}
                exact={true}
            />
            <PublicRoute
                path={Routes.PRODUCTS_SHOWCASE}
                exact={true}
            />
            <PublicRoute
                path={Routes.ORDER_FOR_CUSTOMER}
                exact={true}
            />
            <PublicRoute
                path={Routes.LOGOUT}
                exact={true}
            />

            <Route path={Object.keys(privateMappings)}>
                <PrivateRouteV2 />
            </Route>

            <Route
                path={"*"}
                component={() => (
                    <Suspense fallback={<PreloaderContainer/>}>
                        <NotFoundPageComponent/>
                    </Suspense>
                )}
            />
        </Switch>
    </Router>
);

export default AppRouter
